module.exports = __webpack_public_path__ + "static/media/top14Desktopbanner1220x150.8e090d64.jpg";